"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavContainer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useScrollDirection = require("design_system/hooks/useScrollDirection");
var _Layout = require("design_system/Layout");
var _NavBar = require("../NavBar");
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  w: "w-full",
  h: "s768:h-auto",
  position: "flex flex-col transition-transform ease-in-out duration-500",
  transform: "-translate-y-32"
};
const NavContainer = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    enableHideOnScroll,
    ...props
  } = _ref;
  const {
    isScrolling,
    isScrollingDown
  } = (0, _useScrollDirection.useScrollDirection)({
    enabled: enableHideOnScroll
  });
  const [isDropdownOpen, setIsDropdownOpen] = _react.default.useState(false);
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const isNarrowScreen = width > 0 && width < _useResizeObserver.BREAKPOINTS.s768;
  const onClickOutside = (0, _react.useCallback)(function onClickOutside() {
    // Close the menu when clicking outside of its window/frame;
    // mostly for storybook navigation between stories,
    // which are each in their own iframe.
    if (window.self === window.top) {
      // Not inside an iframe
      return;
    }
    document.body.style.overflow = "auto";
    window.parent.document.removeEventListener("click", onClickOutside);
  }, []);
  const onMenuButtonClick = (0, _react.useCallback)(open => {
    // Bring the MiniNavBar back into view
    window.scrollTo(window.scrollX, window.scrollY - 1);
    // Prevent scrolling underneath the menu
    document.body.style.overflow = open ? "hidden" : "auto";
    // Expand or collapse height to fit the dropdown menu
    setIsDropdownOpen(open);
    if (window.self !== window.top) {
      open ? window.parent.document.addEventListener("click", onClickOutside) : window.parent.document.removeEventListener("click", onClickOutside);
    }
  }, [onClickOutside]);
  (0, _react.useEffect)(() => () => {
    window.parent.document.removeEventListener("click", onClickOutside);
  }, []);
  (0, _react.useEffect)(() => {
    // Close the menu automatically when widening the window
    if (!isNarrowScreen) {
      setIsDropdownOpen(false);
    }
  }, [isNarrowScreen]);
  return /*#__PURE__*/_react.default.createElement(_Layout.Box, _extends({
    as: "nav",
    ref: ref,
    w: THEME.w,
    h: THEME.h,
    className: (0, _classnames.default)(THEME.position, className, {
      [THEME.transform]: isScrollingDown,
      "h-screen": isDropdownOpen
    })
  }, props), _react.Children.map(children, child => {
    if (! /*#__PURE__*/(0, _react.isValidElement)(child)) {
      return null;
    }
    if (child.type === _NavBar.NavBar) {
      return /*#__PURE__*/(0, _react.cloneElement)(child, {
        ...child.props,
        showShadow: isScrolling,
        onMenuButtonClick: (open, setOpen) => {
          var _child$props$onMenuBu, _child$props;
          onMenuButtonClick(open);
          (_child$props$onMenuBu = (_child$props = child.props).onMenuButtonClick) === null || _child$props$onMenuBu === void 0 ? void 0 : _child$props$onMenuBu.call(_child$props, open, setOpen);
        }
      });
    }
    return child;
  }));
});
exports.NavContainer = NavContainer;
NavContainer.displayName = "NavContainer";